import React from "react";
import PartnerWithAptechSection from "../components/PartnerWithAptech/PartnerWithAptech.tsx";
import MetaComponent from "../components/CommonComponents/MetaComponent.tsx";
const PartnerWithAptech =()=>{

    return(
        <div>
              <MetaComponent
        title="Partner with Aptech - Industry Expertise, Strong Support"
        desc="Explore business opportunities with Aptech. Become a partner in vocational skill training and empower learners with industry-relevant skills."
        keywords="partnership opportunities, business partners, partner with aptech"
      />
            <PartnerWithAptechSection />
        </div>
    )
}

export default PartnerWithAptech